import * as React from 'react';
import { Checkbox } from '@repo/ui-web';
import { checkboxStates } from '../../catalog/component-states';
import { StateToggle } from '../../components/StateToggle';

type CheckboxState = (typeof checkboxStates)[number];

export function CheckboxShowcase() {
  const [state, setState] = React.useState<CheckboxState>('unchecked');

  const checkedValue = state === 'checked';
  const disabled = state === 'disabled';

  return (
    <div className="space-y-4">
      <StateToggle options={checkboxStates} value={state} onChange={setState} label="State" />
      <div className="flex items-center gap-2">
        <Checkbox checked={checkedValue} onCheckedChange={() => null} disabled={disabled} />
        <span className="text-sm font-medium text-foreground">Remember this device</span>
      </div>
    </div>
  );
}
